var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGoogleSheets = function SvgGoogleSheets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 67",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.583 0H4.438A4.45 4.45 0 0 0 0 4.438v56.208a4.45 4.45 0 0 0 4.438 4.437h38.458a4.45 4.45 0 0 0 4.437-4.437V17.75L29.583 0Z",
    id: "google-sheets_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.583 0H4.438A4.45 4.45 0 0 0 0 4.438v56.208a4.45 4.45 0 0 0 4.438 4.437h38.458a4.45 4.45 0 0 0 4.437-4.437V17.75L29.583 0Z",
    id: "google-sheets_svg__c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.583 0H4.438A4.45 4.45 0 0 0 0 4.438v56.208a4.45 4.45 0 0 0 4.438 4.437h38.458a4.45 4.45 0 0 0 4.437-4.437V17.75L29.583 0Z",
    id: "google-sheets_svg__e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.583 0H4.438A4.45 4.45 0 0 0 0 4.438v56.208a4.45 4.45 0 0 0 4.438 4.437h38.458a4.45 4.45 0 0 0 4.437-4.437V17.75L29.583 0Z",
    id: "google-sheets_svg__h"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.583 0H4.438A4.45 4.45 0 0 0 0 4.438v56.208a4.45 4.45 0 0 0 4.438 4.437h38.458a4.45 4.45 0 0 0 4.437-4.437V17.75L29.583 0Z",
    id: "google-sheets_svg__j"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.583 0H4.438A4.45 4.45 0 0 0 0 4.438v56.208a4.45 4.45 0 0 0 4.438 4.437h38.458a4.45 4.45 0 0 0 4.437-4.437V17.75L29.583 0Z",
    id: "google-sheets_svg__l"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.583 0H4.438A4.45 4.45 0 0 0 0 4.438v56.208a4.45 4.45 0 0 0 4.438 4.437h38.458a4.45 4.45 0 0 0 4.437-4.437V17.75L29.583 0Z",
    id: "google-sheets_svg__n"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "3.168%",
    cy: "2.717%",
    fx: "3.168%",
    fy: "2.717%",
    r: "161.249%",
    gradientTransform: "matrix(1 0 0 .72727 0 .007)",
    id: "google-sheets_svg__p"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.1,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.005%",
    y1: "8.586%",
    x2: "50.005%",
    y2: "100.014%",
    id: "google-sheets_svg__f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.02,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.833 .958)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "google-sheets_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google-sheets_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.583 0H4.438A4.45 4.45 0 0 0 0 4.438v56.208a4.45 4.45 0 0 0 4.438 4.437h38.458a4.45 4.45 0 0 0 4.437-4.437V17.75L36.98 10.354 29.583 0Z",
    fill: "#0F9D58",
    fillRule: "nonzero",
    mask: "url(#google-sheets_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.833 .958)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "google-sheets_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google-sheets_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.833 31.802V53.25H35.5V31.802H11.833Zm10.354 18.49h-7.395v-3.698h7.396v3.698Zm0-5.917h-7.395v-3.698h7.396v3.698Zm0-5.917h-7.395V34.76h7.396v3.698Zm10.355 11.834h-7.396v-3.698h7.396v3.698Zm0-5.917h-7.396v-3.698h7.396v3.698Zm0-5.917h-7.396V34.76h7.396v3.698Z",
    fill: "#F1F1F1",
    fillRule: "nonzero",
    mask: "url(#google-sheets_svg__d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.833 .958)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "google-sheets_svg__g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google-sheets_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-sheets_svg__f)",
    fillRule: "nonzero",
    mask: "url(#google-sheets_svg__g)",
    d: "M30.881 16.452 47.333 32.9V17.75z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.833 .958)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "google-sheets_svg__i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google-sheets_svg__h"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#google-sheets_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.583 0v13.313a4.436 4.436 0 0 0 4.438 4.437h13.312L29.583 0Z",
    fill: "#87CEAC",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.833 .958)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "google-sheets_svg__k",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google-sheets_svg__j"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.438 0A4.45 4.45 0 0 0 0 4.438v.37A4.45 4.45 0 0 1 4.438.37h25.145V0H4.438Z",
    fillOpacity: 0.2,
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#google-sheets_svg__k)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.833 .958)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "google-sheets_svg__m",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google-sheets_svg__l"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.896 64.714H4.437A4.45 4.45 0 0 1 0 60.276v.37a4.45 4.45 0 0 0 4.438 4.437h38.458a4.45 4.45 0 0 0 4.437-4.437v-.37a4.45 4.45 0 0 1-4.437 4.438Z",
    fillOpacity: 0.2,
    fill: "#263238",
    fillRule: "nonzero",
    mask: "url(#google-sheets_svg__m)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.833 .958)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "google-sheets_svg__o",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google-sheets_svg__n"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.02 17.75a4.436 4.436 0 0 1-4.437-4.438v.37a4.436 4.436 0 0 0 4.438 4.438h13.312v-.37H34.021Z",
    fillOpacity: 0.1,
    fill: "#263238",
    fillRule: "nonzero",
    mask: "url(#google-sheets_svg__o)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.583 0H4.438A4.45 4.45 0 0 0 0 4.438v56.208a4.45 4.45 0 0 0 4.438 4.437h38.458a4.45 4.45 0 0 0 4.437-4.437V17.75L29.583 0Z",
    fill: "url(#google-sheets_svg__p)",
    fillRule: "nonzero",
    transform: "translate(.833 .958)"
  }))));
};

export default SvgGoogleSheets;